import React, { SVGProps } from 'react'
const SvgSidenavWalletActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#Sidenav-Wallet-Active_svg__a)">
      <path
        fill={props.fill || 'var(--color-cta)'}
        fillRule="evenodd"
        d="M11.81.05a2.417 2.417 0 0 1 3.315 2.244v1.913h1.75A2.292 2.292 0 0 1 19.167 6.5v8.333a2.292 2.292 0 0 1-2.292 2.292H3.542a2.292 2.292 0 0 1-2.292-2.292v-.418a.747.747 0 0 1-.125-.415V5.396c0-.647.394-1.23.995-1.47L11.81.05Zm1.815 2.244v1.913H5.457l6.91-2.764a.917.917 0 0 1 1.258.85Zm2.417 9.622a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Sidenav-Wallet-Active_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgSidenavWalletActive
